<template>
  <div
    class="tab-pane fade show active"
    id="Profile"
    role="tabpanel"
    aria-labelledby="Profile-tab"
  >

    <mainHeader title="PROFILE"></mainHeader>
    <div style="padding: 0 12px;">
    <div class="card">
      <div class="card-body">
        <h5 class="card-title">General Information</h5>
        <div class="settings-profile">
          <form>
            <!-- <img src="/img/avatar.svg" alt="avatar" />
            <div class="custom-file">
              <input type="file" class="form-control" />
            </div> -->

            <div class="row mt-4">
              <div class="col-md-6">
                <label htmlFor="formFirst">Nickname</label>
                <input
                  id="formFirst"
                  type="text"
                  class="form-control"
                  placeholder="Nickname"
                  v-model="nickname"
                />
              </div>
              <div class="col-md-12">
                <button type="button" class="btn btn-primary" @click="updateNickname">Update</button>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
    <div class="card">
      <div class="card-body">
        <h5 class="card-title">Set withdrawal password</h5>
        <div class="settings-profile">
          <form>
            <div class="row">
              <div class="col-md-6">
                <label htmlFor="currentPass"> Current password </label>
                <input
                  id="currentPass"
                  type="password"
                  class="form-control"
                  placeholder="Enter your password"
                  v-model="currentPayPassword"
                />
              </div>
              <div class="col-md-6">
                <label htmlFor="newPass">New password</label>
                <input
                  id="newPass"
                  type="password"
                  class="form-control"
                  placeholder="Enter new password"
                  v-model="newPayPassword"
                />
              </div>
              <div class="col-md-12">
                <button type="button" class="btn btn-primary" @click="setPayPwd">Update</button>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
    <div class="card">
      <div class="card-body">
        <h5 class="card-title">Changing Login Password</h5>
        <div class="settings-profile">
          <form>
            <div class="row">
              <div class="col-md-6">
                <label htmlFor="currentPass1"> Current password </label>
                <input
                  id="currentPass1"
                  type="password"
                  class="form-control"
                  placeholder="Enter your password"
                  v-model="currentPassword"
                />
              </div>
              <div class="col-md-6">
                <label htmlFor="newPass1">New password</label>
                <input
                  id="newPass1"
                  type="password"
                  class="form-control"
                  placeholder="Enter new password"
                  v-model="newPassword"
                />
              </div>
              <div class="col-md-12">
                <button type="button" class="btn btn-primary" @click="changePwd">Update</button>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
    <button class="btn btn-danger" @click="logout">Logout</button>
    </div>
  </div>
</template>

<script>
import { updateNickname, changePwd, setPayPwd } from "@/apis/user";
import mainHeader from "../../../components/mainHeader.vue";
import { message } from "@/utils/message";
export default {
  components: {mainHeader},
  data() {
    return {
      nickname: "",
      currentPassword: "",
      newPassword: "",
      currentPayPassword: "",
      newPayPassword: "",
    };
  },
  created() {
    this.getUserInfo();
  },
  methods: {
    async getUserInfo() {
      await this.$store.dispatch("getUserInfo");
      if (this.$store.state.userInfo) {
        this.nickname = this.$store.state.userInfo.nickname;
      }
    },
    updateNickname() {
      if (!this.nickname) {
        message.error("Nickname cannot be empty");
      }
      updateNickname({ nickname: this.nickname }).then((res) => {
        if (res.code === 0) {
          message.success("Nickname updated successfully");
          this.getUserInfo();
        }
      });
    },
    changePwd() {
      changePwd({ pwd: this.currentPassword, new_pwd: this.newPassword }).then((res) => {
        if (res.code === 0) {
          message.success("Password updated successfully");
          this.currentPassword = "";
          this.newPassword = "";
        }
      });
    },
    setPayPwd() {
      setPayPwd({ old_pwd: this.currentPayPassword, pay_pwd: this.newPayPassword }).then((res) => {
        if (res.code === 0) {
          message.success("Withdrawal password updated successfully");
          this.currentPayPassword = "";
          this.newPayPassword = "";
        }
      });
    },
    logout() {
      this.$store.dispatch("clearLoginData");
      this.$router.push("/login");
    },
  },
};
</script>

<style></style>
